import Vue from 'vue';
export const Event = new Vue();

export default {
    messageSuccess(message) {
        Event.$emit('customMessage', message, 'success', true);
        // Materialize.toast('<b>'+message+'</b>', 3000, 'rounded green');
    },
    messageError(message) {
        Event.$emit('customMessage', message, 'danger',  true);
        // Materialize.toast('<b>'+message+'</b>', 3000, 'rounded red');
    },
}


// WEBPACK FOOTER //
// ./src/helpers/message.js